import { render, staticRenderFns } from "./AiChatDialog.vue?vue&type=template&id=0f721a2e&scoped=true"
import script from "./AiChatDialog.vue?vue&type=script&lang=js"
export * from "./AiChatDialog.vue?vue&type=script&lang=js"
import style0 from "./AiChatDialog.vue?vue&type=style&index=0&id=0f721a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f721a2e",
  null
  
)

export default component.exports